module.exports = __webpack_public_path__ + "static/media/IMG_3250.8e59cfc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/IMG_3250.png
// module id = 318
// module chunks = 0